import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { Observable } from 'rxjs';
import { FooterDataType } from './def/footer-content';
import { map } from 'rxjs/internal/operators/map';
import { catchError } from 'rxjs/internal/operators/catchError';
import { of } from 'rxjs/internal/observable/of';
import { BaseContentService } from './base-content-service';

@Injectable()
export class FooterContentService extends BaseContentService<FooterDataType> {
  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService
  ) {
    super(http, configService, FooterContentService.staticFooter);
  }

  get data$(): Observable<FooterDataType> {
    if (!this.loaded) {
      return this.getFooterData();
    }

    return of(this.data);
  }

  getFooterData(): Observable<FooterDataType> {
    const url = `${this.serviceBaseUrl}footer`;
    return this.get<FooterDataType>(url).pipe(
      map(data => {
        this.data = this.footerMapper(data);
        this.loaded = true;
        return this.data;
      }),
      catchError(this.handleError)
    );
  }

  private footerMapper(data: FooterDataType): FooterDataType {
    if (!data) return;

    return data;
  }

  private static staticFooter: FooterDataType = {
    pageName: 'footer',
    messages: [
      {
        heading: '',
        description: '',
        image: null,
        displayItems: []
      }
    ],
    mainLinks: [
      {
        heading: '',
        displayItems: [
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          }
        ]
      }
    ],
    subLinks: [
      {
        heading: '',
        displayItems: [
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: {
              Anchor: '',
              Class: '',
              Text: '',
              Query: '',
              Title: '',
              Url: '',
              Target: '',
              TargetId: '',
              Type: 2,
              Style: ''
            },
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: {
              Anchor: '',
              Class: '',
              Text: '',
              Query: '',
              Title: '',
              Url: '',
              Target: '',
              TargetId: '',
              Type: 2,
              Style: ''
            },
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: {
              Anchor: '',
              Class: '',
              Text: '',
              Query: '',
              Title: '',
              Url: '',
              Target: '',
              TargetId: '',
              Type: 2,
              Style: ''
            },
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: {
              Anchor: '',
              Class: '',
              Text: '',
              Query: '',
              Title: '',
              Url: '',
              Target: '',
              TargetId: '',
              Type: 2,
              Style: ''
            },
            orderId: null,
            image: null,
            icon: ''
          }
        ]
      }
    ],
    socialLinks: [
      {
        heading: '',
        displayItems: [
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: {
              Anchor: '',
              Class: '',
              Text: '',
              Query: '',
              Title: '',
              Url: '',
              Target: '',
              TargetId: '',
              Type: 2,
              Style: ''
            },
            orderId: null,
            image: null,
            icon: ''
          }
        ]
      }
    ]
  };
}
